/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
// material
import { ConfigToggle } from 'material/expandablesection/v2';
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import PreviewConfig from 'material/previewconfig/previewconfig'
// styles
import injectSheet from 'react-jss'
import styles from './reactiontooltip_styles'
import Emoji from 'pages/dashboard/commenting/commentingconfigv2/sitethemesection/components/emoji/emoji';


/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT CONFIG V2: GENERAL SECTION : REACTION TOOLTIP ~~~~~~~~~~ ========== */
const ReactionTooltip = injectSheet(styles)((props) => {

  const { enableTooltipHoverOnEmoji, onChange } = props

  return (
    <Space gap={48} justifyContent={'space-between'} klass={`reactioncounts ${props.classes.reactiontooltip}`} > 
      <SectionGroupV2 
        indented={true} 
        title={'Reaction tooltip'} 
        description={''}
        rowGap={16} 
        direction={'column'}
      >
        <ConfigToggle 
          title={'Enable tooltip on emoji hover'}
          checked={enableTooltipHoverOnEmoji}
          onChange={val => onChange({ enableTooltipHoverOnEmoji: val})}
        />
      </SectionGroupV2>
      <PreviewConfig>
        <Space direction={'column'} alignItems={'center'} justifyContent={'center'}>
          {enableTooltipHoverOnEmoji && <span className='hovertooltip'>LIKE</span>}
          <Emoji size={50} name={'LIKE'} type={'FLAT'} />
        </Space>
      </PreviewConfig>
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ReactionTooltip;